<div class="doc-page">
    <article class="doc-shell">
        <header class="doc-header">
            <p class="doc-eyebrow">Condizioni di utilizzo</p>
            <h1 class="doc-title" itemprop="headline">REGOLAMENTO</h1>
            <p class="doc-lead">Le regole da rispettare per utilizzare il servizio.</p>
        </header>

        <div class="doc-card">
            <ol type="1" class="doc-list">
                <li>
                    L’operatore non può effettuare chiamate senza identificarsi come operatore del servizio per sordi.
                </li>
                <li>
                    Ogni volta che si richiede di fare una telefonata é obbligatorio fornire all’operatore il numero di telefono da chiamare.
                </li>
                <li>
                    Non è possibile chiedere all’operatore opinioni personali circa l’attendibilità della persona udente.
                </li>
                <li>
                    Le chiamate a pagamento (ad esempio 899, 166, 892 … ) sono ammissibili solo se rivolte ad accedere a servizi di pubblica utilità. In questo caso l’utente deve comunicare preventivamente all’operatore l’oggetto della richiesta, l’operatore valuterà se si tratta di servizi abilitati, nel rispetto della policy del servizio. Sono invece respinte le richieste di contattare numeri a pagamento per scommesse, lotterie, concorsi a premi, telequiz, oroscopo ecc.
                </li>
                <li>
                    Non é possibile usare il servizio per i telegrammi.
                </li>
                <li>
                    Le chiamate di carattere privato devono avere una durata massima di 15 minuti per consentire anche agli utenti in coda di usufruire del servizio.
                </li>
                <li>
                    Se il numero chiamato risulta occupato (o non risponde nessuno) l’operatore effettuerà diversi tentativi.
                </li>
                <li>
                    É possibile effettuare una sola telefonata alla volta a meno che l’operatore stesso non comunichi l’assenza di coda in entrata e si renda disponibile per una seconda chiamata; questo vale anche per gli sms e le e­mail che, quindi, devono contenere un solo numero di telefono da contattare.
                </li>
                <li>
                    É severamente vietato usare il servizio per fare chiamate dal contenuto osceno, illegale e ogni altra finalità e modalità di comunicazione che offenda la dignità della persona, di terzi, il decoro e violi la normativa vigente.
                </li>
                <li>
                    Quando si effettuano chiamate verso gestori che trattano dati sensibili (esempio Enel, banche, ecc.) è possibile che l’operatore non venga autorizzato dal destinatario della chiamata a trattare i dati. In questo caso la chiamata non verrà portata a termine e non verrà ripetuta.
                </li>
                <li>
                    É obbligatorio registrarsi al servizio per privacy, senza registrazione non è possibile fare le chiamate. Possiamo fare le chiamate soltanto se si tratta di un’emergenza.
                </li>
                <li>
                    In fase di registrazione non si possono utilizzare nomi e cognomi di fantasia.
                </li>
                <li>
                    É vietato usare il servizio videochat come un servizio di interpretariato ma unicamente mediante telefonate in cui l’operatore presterà la propria voce.
                </li>
                <li>
                    É vietato fare la chiamata con l’account registrato di un’altra persona anche se è di un parente, bisogna utilizzare il proprio account. E’ possibile fare le chiamate per terze persone invece dichiarando chiaramente “buona sera, sono Mario Rossi e sto chiamando per il conto di mio padre Angelo Rossi…”.
                </li>
                <li>
                    Durante la videochat è necessario avere un abbigliamento adeguato (evitare torso nudo, ecc.).
                </li>
                <li>
                    E’ vietato usare termini volgari e bestemmiare.
                </li>
                <li>
                    Se l’utente viola il regolamento, comunic&#64;ens può bloccare la sua utenza.
                </li>
                <li>
                    Non è possibile chiedere all’operatore di recuperare le conversazione fatte precedentemente con un altro operatore. Questo vale anche per i numeri delle chiamate precedenti, per ogni chiamata bisogna scrivere il numero da chiamare.
                </li>
                <li>
                    Non è possibile effettuare chiamate all’estero.
                </li>
                <li>
                    Non è possibile fare chiamate o scrivere in lingue che non siano la lingua italiana.
                </li>
            </ol>
        </div>
    </article>
</div>
